import { render, staticRenderFns } from "./questionTotal.vue?vue&type=template&id=50d79f78&scoped=true&"
import script from "./questionTotal.vue?vue&type=script&lang=js&"
export * from "./questionTotal.vue?vue&type=script&lang=js&"
import style0 from "./questionTotal.vue?vue&type=style&index=0&id=50d79f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d79f78",
  null
  
)

export default component.exports